/* PagingActivityFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

const mongoDbQuery = {
    $or: [
        {
            activityType: "create",
        },
        {
            $and: [{activityType: "update"}, {patch: {$exists: true, $nin: [[], null]}}],
        },
    ],
};

class PagingActivityFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedAuditsFeed(
            mongoDbQuery,
            this._entityFields,
            this._sort,
            {skip: 0, limit: this._pageSize * 2}
        );
    }
    _feedReestablish() {
        return this._feed.reestablishFeed(
            this._userSession.activeOrganization.id,
            mongoDbQuery,
            this._entityFields,
            this._sort
        );
    }
}

module.exports = PagingActivityFeed;
